import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "content"];
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Table = props => {
  var {
    content: {
      thead,
      tbody
    } = {
      thead: [],
      tbody: []
    }
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_jsxs("table", _extends({
    className: "border-collapse table-auto w-full"
  }, rest, {
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        children: thead == null ? void 0 : thead.map(_ref => {
          var {
            value
          } = _ref;
          return /*#__PURE__*/_jsx("th", {
            className: "border-b border-neutral font-black p-4 pl-8 pt-0 pb-3 text-left",
            children: value
          });
        })
      })
    }), /*#__PURE__*/_jsx("tbody", {
      className: "text-sm",
      children: tbody == null ? void 0 : tbody.map(_ref2 => {
        var {
          body
        } = _ref2;
        return /*#__PURE__*/_jsx("tr", {
          children: body == null ? void 0 : body.map(_ref3 => {
            var {
              value
            } = _ref3;
            return /*#__PURE__*/_jsx("td", {
              className: "border-b border-neutral p-4 pl-8",
              children: value
            });
          })
        });
      })
    })]
  }));
};
//# sourceMappingURL=table.js.map